// extracted by mini-css-extract-plugin
export default {"menu":"Nav-Menu_menu__ha9Yo","item":"Nav-Menu_item__I2w83","name":"Nav-Menu_name__F+LzB","icon":"Nav-Menu_icon__ZMmXa","activeItem":"Nav-Menu_activeItem__sRoe9"};